module.exports = __webpack_public_path__ + "assets/img/9339c8e5721bc2c06cea5191d311fc95.svg";